
  import JobListingFilter from '@/components/elements/JobListingFilter';
  import NoDataToShow from '@/components/elements/NoDataToShow';
  import JobAlert from '@/components/JobAlert';
  import SendViaEmail from '@/components/SendViaEmail';
  import JobsWithTypesense from '@/mixins/JobsWithTypesense';

  export default {
    name: 'JobListingWithTypesense',
    components: {
      NoDataToShow,
      JobListingFilter,
      JobListingFilterDialog: () =>
        import('@/components/filter-dialogs/JobListingFilterDialog'),
      Pagination: () => import('@/components/Pagination'),
      JobListing: () => import('@/components/elements/JobListing'),
      SendViaEmail,
      JobAlert,
      RichText: () => import('@/components/elements/RichText'),
      CustomBigTitle: () => import('@/components/CustomBigTitle'),
    },
    mixins: [JobsWithTypesense],
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    head() {
      const head = {meta: []};
      const query = Object.assign({}, this.$route.query);
      const canonical_links = [];

      canonical_links.push({
        rel: 'canonical',
        hid: 'canonical',
        href:
          process.env.NUXT_ENV_BASE_URL +
          this.localePath({
            query: {page: this.page > 1 ? this.page : undefined},
          }),
      });

      if (this.page > 1) {
        query.page = this.page - 1;
        canonical_links.push({
          rel: 'prev',
          hid: 'prev',
          href:
            process.env.NUXT_ENV_BASE_URL +
            this.localePath({
              query: query,
            }),
        });
      }

      if (this.page < this.countPages) {
        query.page = this.page + 1;
        canonical_links.push({
          rel: 'next',
          hid: 'next',
          href: this.localePath({
            query: query,
          }),
        });
      }

      head.link = canonical_links;

      if (this.$route.query.user_search || this.page > 1) {
        head.meta.push({
          name: 'robots',
          content: 'noindex',
        });
        head.meta.push({
          name: 'googlebot',
          content: 'noindex',
        });
      }

      return head;
    },
    updated() {
      const filterBar = document.querySelector('#pb-filter-bar>div');
      const mainTitle = document.querySelector('#pb-joblisting-main-title');
      if (
        mainTitle &&
        filterBar &&
        mainTitle.getBoundingClientRect().height >
          filterBar.getBoundingClientRect().height + 100
      ) {
        document.getElementById('pb-inside-div').style.position = 'absolute';
        document.getElementById('pb-inside-div').style.left = '0px';
        document.getElementById('pb-inside-div').style.width = '100%';
        document.getElementById('pb-inside-div').style.padding = 'inherit';
      } else {
        document.getElementById('pb-inside-div').style.position = 'relative';
        document.getElementById('pb-inside-div').style.padding = 'initial';
      }
    },
    mounted() {
      const filterBarContainer = document.querySelector('#pb-filter-bar');
      const filterBar = document.querySelector('#pb-filter-bar>div');
      let timeout;
      this.handleScroll = () => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => {
          const vh = document.documentElement.clientHeight;
          const boundingRect = filterBar.getBoundingClientRect();
          if (boundingRect.bottom < vh) {
            const currentTop = parseInt(filterBar.style.top, 10);
            filterBar.style.top = `${
              currentTop + (vh - boundingRect.bottom)
            }px`;
          }
          if (boundingRect.top - vh > -vh) {
            const currentTop = parseInt(filterBar.style.top, 10);
            filterBar.style.top = `${currentTop - boundingRect.top + 100}px`;
          }
          const newTop = parseInt(filterBar.style.top, 10);
          const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
          filterBar.style.top = `${clamp(
            newTop,
            0,
            filterBarContainer.getBoundingClientRect().height -
              boundingRect.height
          )}px`;
        }, 100);
      };

      if (filterBarContainer && filterBar) {
        document.addEventListener('scroll', this.handleScroll);
      }
    },
    destroyed() {
      if (this.handleScroll) {
        document.removeEventListener('scroll', this.handleScroll);
      }
    },
  };
